import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { MatchingState } from './types';

export const getters: GetterTree<MatchingState, RootState> = {};
